import { Link } from "react-router-dom";
import { allCategories, allComics } from "@/utils/comics";

const iconStyles = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-700",
];

export default function CategoryQuickLinks() {
  return (
    <section aria-labelledby="quick-category-title" className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
      <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
        <div>
          <span className="mb-1.5 flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-primary-600">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
            快捷入口
          </span>
          <h2
            id="quick-category-title"
            className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl"
          >
            按题材浏览漫画
          </h2>
        </div>
        <Link
          to="/category/all"
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
        >
          查看全部漫画
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {allCategories.map((category, index) => {
          const count = allComics.filter((comic) => comic.categoryId === category.id).length;
          return (
            <Link
              key={category.id}
              to={`/category/${category.id}`}
              className="group flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-3.5 transition-colors hover:border-primary-300 hover:bg-primary-50/40 md:p-4"
            >
              <span
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md ${
                  iconStyles[index % iconStyles.length]
                }`}
              >
                <i className={`${category.icon} text-xl`}></i>
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-1.5">
                  <span className="truncate font-heading text-sm font-semibold text-foreground-950">
                    {category.name}
                  </span>
                  <span className="shrink-0 rounded bg-background-100 px-1 py-0.5 text-[10px] text-foreground-500">
                    {count} 部
                  </span>
                </span>
                <span className="mt-1 block truncate text-[11px] text-foreground-500">
                  {category.subtitle}
                </span>
              </span>
              <i className="ri-arrow-right-up-line ml-auto hidden text-foreground-300 transition-colors group-hover:text-primary-500 sm:block"></i>
            </Link>
          );
        })}
      </div>
    </section>
  );
}